import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/ui-bits';
import { fmtRelative } from '@/lib/format';

export default function SuperAuditLogsPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/superadmin/audit-logs?limit=500').then((r) => setLogs(r.data.logs)); }, []);
  return (
    <div>
      <PageHeader title="Audit logs globales" description="Eventos de toda la plataforma." />
      <div className="surface">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-muted-foreground border-b border-border"><th className="px-3 py-2">Cuándo</th><th className="px-3 py-2">Tenant</th><th className="px-3 py-2">Acción</th><th className="px-3 py-2">Objeto</th><th className="px-3 py-2">Detalles</th></tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.id} className="h-10 border-b border-border/70">
              <td className="px-3 text-xs text-muted-foreground">{fmtRelative(l.created_at)}</td>
              <td className="px-3 text-xs font-mono">{(l.tenant_id || 'global').slice(0, 8)}</td>
              <td className="px-3"><span className="chip">{l.action}</span></td>
              <td className="px-3 text-xs">{l.target_type}</td>
              <td className="px-3 font-mono text-xs text-muted-foreground truncate max-w-[400px]">{l.meta ? JSON.stringify(l.meta) : ''}</td>
            </tr>
          ))}{logs.length === 0 && <tr><td colSpan="5" className="text-center text-sm text-muted-foreground py-8">Sin eventos.</td></tr>}</tbody>
        </table>
      </div>
    </div>
  );
}
